import {
    icons,
    SET_SEARCH,
    UPDATE_STATUS,
    UPDATE_LIST,
    RESET_LIST,
    UPDATE_INVIEW
} from "../types";
import { _ } from "js/vendor";
const INITIAL_STATE = {
    data: [],
    list: [],
    stats: null,
    search: null,
    inView: false,
    error: null
};

export default (state = INITIAL_STATE, action) => {
    let { result, type } = action;

    switch (type) {
        case icons.fetchSuccess:
            return { ...state, data: _.values(result), status: "success" };

        case icons.fetchError:
            return { ...state, error: result, status: "error" };

        case SET_SEARCH:
            return { ...state, search: result };

        case UPDATE_LIST:
            return { ...state, list: [...state.list, ...result] };

        case UPDATE_STATUS:
            return { ...state, status: result };

        case RESET_LIST:
            return { ...state, list: [], status: "success" };

        case UPDATE_INVIEW:
            return { ...state, inView: result };

        default:
            return state;
    }
};
